var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1201 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(1201 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1202 56)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.244,29.9A9.124,9.124,0,0,0,16,29.9h1.4a7.72,7.72,0,0,1,15.436,0ZM25.122,19.608a4.805,4.805,0,1,0-4.912-4.8A4.859,4.859,0,0,0,25.122,19.608Zm0-1.373A3.432,3.432,0,1,1,28.631,14.8,3.47,3.47,0,0,1,25.122,18.235Z",
    transform: "translate(-15.171 -10)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.f9ee1b3c63b57e6e4a4e7af32f3f42c9.svg";
export { ForwardRef as ReactComponent };